import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const deleteMissionAction = createAsyncThunk(
    'delete-mission',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/admins/api/delete-mission`, { mission_id: data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const deleteMissionSlice = createSlice({
    name: 'delete-mission',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(deleteMissionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(deleteMissionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(deleteMissionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const deleteMissionReducer = deleteMissionSlice.reducer    